import { TranscparencySpentData } from "apiTypes";
import DonationDetailsCard from "components/ReuseableCompos/DonationDetailsCard";
import DonationDetailsModal from "components/ReuseableCompos/DonationDetailsModal";
import { memo, useCallback, useState } from "react";
import useModal from "../../../customHooks/useModal";
import InfinteDataSoruceHandler from "../../SharedLayoutComponents/InfinteDataSoruceHandler";
import DonationAccordionSkeleton from "../../Skeletons/DonationAccordionSkeleton";

const SpentCards = ({ selectedDate }) => {
  const [clickedDonationObj, setClickedDonationObj] =
    useState<TranscparencySpentData | null>(null);

  const {
    showModal: showModalOffCanvas,
    handleCloseModal: handleCloseModalOffCanvas,
    handleShowModal: handleShowModalOffCanvas,
  } = useModal();

  const onDonationCardClick = useCallback((donationObj: any) => {
    setClickedDonationObj(donationObj);
    handleShowModalOffCanvas();
  }, []);

  return (
    <>
      <InfinteDataSoruceHandler
        skeleton={DonationAccordionSkeleton}
        endPoint={`transparency/donations/spent?date=${selectedDate}`}
        resourceName="donation"
        skeletonAmount={6}
        getMoreSkeletonAmount={4}
        inifiteScrollClassName="overflow-hidden"
        proxy={false}
        inifiteScrollProps={{
          no100vh: true,
          style: {
            height: "100%",
          },
        }}
      >
        <DonationDetailsCard
          onDonationCardClick={onDonationCardClick}
          selectedItems={["amount", "payout_id", "short_name"]}
        />
      </InfinteDataSoruceHandler>

      <DonationDetailsModal
        details={clickedDonationObj?.details}
        open={showModalOffCanvas}
        handleClose={handleCloseModalOffCanvas}
      />
    </>
  );
};

export default memo(SpentCards);
